module.exports = __webpack_public_path__ + "static/media/2.30a60ab4.jpg";